import { ChangeColor } from './ChangeColor';

export class ChangeTextOnGreyColor extends ChangeColor {
  type: string = 'ChangeTextOnGreyColor';
}
